import { nameIn } from './categories.ts';
import { variantLabel, type OptionIndex } from './options.ts';
import type { Product } from './product.ts';
import { healthOfLevels, sumAvailable, type StockHealth, type StockLevel } from '../inventory/inventory.ts';
import type { StockRow } from '../inventory/StockMatrix.tsx';

export const productNameOf = (product: Product, locale: string): string =>
  nameIn(product, locale, product.reference ?? product.id);

export const variantRows = (product: Product, index: OptionIndex): readonly StockRow[] =>
  product.variants.map((variant) => ({
    variantId: variant.id,
    label: variantLabel(variant.optionValueIds, index, variant.sku),
    price: variant.price.amount,
    ...(variant.optionValueIds.length === 0 ? {} : { detail: variant.sku }),
  }));

export const namedVariantRows = (
  products: readonly Product[],
  index: OptionIndex,
  locale: string,
): readonly StockRow[] =>
  products.flatMap((product) => {
    const name = productNameOf(product, locale);
    return variantRows(product, index).map((row) => ({ ...row, label: `${name} · ${row.label}` }));
  });

export type ProductStock = { readonly available: number; readonly health: StockHealth };

export const stockOfProduct = (product: Product, levels: readonly StockLevel[]): ProductStock => {
  const variantIds = new Set(product.variants.map((variant) => variant.id));
  const own = levels.filter((level) => variantIds.has(level.variantId));
  return { available: sumAvailable(own), health: healthOfLevels(own) };
};
